import { useEffect } from "react";
import "./PrivacyPolicy.css";
import Footer from "../sections/Footer";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="privacy-policy">
        <h2>Polityka Prywatności</h2>
        <p className="privacy-updated">Ostatnia aktualizacja: 11 marca 2026</p>

        <h3>§ 1. Administrator danych osobowych</h3>
        <p>
          Administratorem Państwa danych osobowych jest firma{" "}
          <strong>Jagoda Rybacka - Aesthetic Code</strong>, NIP: 7831841036,
          e-mail do kontaktu: sweep.3d.lab@gmail.com (dalej: „Administrator").
        </p>
        <p>
          Administrator nie wyznaczył Inspektora Ochrony Danych. W sprawach
          dotyczących przetwarzania danych osobowych prosimy o kontakt pod
          adresem e-mail: sweep.3d.lab@gmail.com.
        </p>

        <h3>§ 2. Podstawy prawne i zakres stosowania</h3>
        <p>Niniejsza Polityka Prywatności została opracowana zgodnie z:</p>
        <ul>
          <li>
            Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia
            27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z
            przetwarzaniem danych osobowych i w sprawie swobodnego przepływu
            takich danych (dalej: „RODO"),
          </li>
          <li>
            Ustawą z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z
            2019 r. poz. 1781),
          </li>
          <li>
            Ustawą z dnia 18 lipca 2002 r. o świadczeniu usług drogą
            elektroniczną (Dz.U. z 2024 r. poz. 1513).
          </li>
        </ul>
        <p>
          Polityka dotyczy danych osobowych zbieranych za pośrednictwem serwisu
          internetowego https://sweeplab.org (dalej: „Serwis"), w tym danych
          przesyłanych przez zewnętrzne formularze kontaktowe lub zamówieniowe.
        </p>

        <h3>§ 3. Cele, podstawy prawne i zakres przetwarzanych danych</h3>
        <p>
          Administrator przetwarza Państwa dane osobowe w następujących celach:
        </p>

        <h4>
          3.1. Obsługa zapytań i realizacja zamówień (formularz
          kontaktowy/zamówieniowy)
        </h4>
        <p>
          Dane zbierane przez formularz obejmują: imię lub nazwę firmy, adres
          e-mail, numer telefonu, adres dostawy, nazwę i opis produktu, grupę
          docelową produktu, szacowany wolumen produkcji, budżet, informację o
          posiadaniu modelu 3D, szczegółowy opis koncepcji produktu, przydatne
          linki, kolor produktu, materiały i rodzaj materiału, wymiary,
          preferencje dotyczące przeglądu prototypu, wskaźnik pilności oraz
          dodatkowe uwagi.
        </p>
        <p>
          Ponadto formularz umożliwia przesyłanie plików — modeli 3D (np. STL,
          STEP, OBJ), szkiców, zdjęć referencyjnych i innych materiałów
          graficznych (dalej: „Pliki").
        </p>
        <ul>
          <li>
            <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. b RODO —
            przetwarzanie jest niezbędne do podjęcia działań na żądanie osoby,
            której dane dotyczą, przed zawarciem umowy, oraz do wykonania umowy.
          </li>
          <li>
            <strong>Okres przechowywania:</strong> Dane przetwarzane są przez
            czas trwania negocjacji i realizacji zamówienia. W przypadku zapytań,
            które nie prowadzą do zawarcia umowy, dane są usuwane najpóźniej po{" "}
            <strong>12 miesiącach</strong> od ostatniego kontaktu.
          </li>
        </ul>

        <h4>
          3.2. Wystawianie faktur i wypełnianie obowiązków podatkowych i
          rachunkowych
        </h4>
        <p>
          Dane obejmują: nazwę firmy, adres, NIP, dane dotyczące transakcji.
        </p>
        <ul>
          <li>
            <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. c RODO —
            przetwarzanie jest niezbędne do wypełnienia obowiązku prawnego
            ciążącego na Administratorze, w szczególności wynikającego z ustawy z
            dnia 29 sierpnia 1997 r. — Ordynacja podatkowa oraz ustawy z dnia 29
            września 1994 r. o rachunkowości.
          </li>
          <li>
            <strong>Okres przechowywania:</strong>{" "}
            <strong>5 lat</strong> od końca roku kalendarzowego, w którym upłynął
            termin płatności podatku (art. 70 § 1 Ordynacji podatkowej).
          </li>
        </ul>

        <h4>3.3. Ustalenie, dochodzenie lub obrona przed roszczeniami</h4>
        <ul>
          <li>
            <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. f RODO —
            prawnie uzasadniony interes Administratora polegający na ochronie
            jego praw.
          </li>
          <li>
            <strong>Okres przechowywania:</strong> Do czasu przedawnienia
            roszczeń — <strong>3 lata</strong> dla roszczeń związanych z
            działalnością gospodarczą (art. 118 Kodeksu cywilnego), licząc od
            dnia wymagalności roszczenia, z zastrzeżeniem, że koniec terminu
            przedawnienia przypada na ostatni dzień roku kalendarzowego.
          </li>
        </ul>

        <h4>3.4. Prowadzenie korespondencji e-mail i telefonicznej</h4>
        <ul>
          <li>
            <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. f RODO —
            prawnie uzasadniony interes Administratora polegający na prowadzeniu
            bieżącej korespondencji związanej z prowadzoną działalnością.
          </li>
          <li>
            <strong>Okres przechowywania:</strong> Przez czas trwania
            korespondencji, a następnie przez okres przedawnienia ewentualnych
            roszczeń.
          </li>
        </ul>

        <h4>
          3.5. Zapewnienie bezpieczeństwa Serwisu
        </h4>
        <ul>
          <li>
            <strong>Podstawa prawna:</strong> art. 6 ust. 1 lit. f RODO —
            prawnie uzasadniony interes Administratora polegający na zapewnieniu
            bezpieczeństwa informatycznego Serwisu.
          </li>
          <li>
            <strong>Okres przechowywania:</strong> Przez okres funkcjonowania
            Serwisu lub do czasu wniesienia skutecznego sprzeciwu.
          </li>
        </ul>

        <h3>§ 4. Przesyłane pliki — modele 3D, szkice i zdjęcia</h3>
        <p>
          Pliki przesyłane za pośrednictwem formularza zamówieniowego (modele 3D,
          szkice techniczne, zdjęcia referencyjne i inne materiały graficzne)
          przetwarzane są <strong>wyłącznie</strong> w celu realizacji zamówienia
          — wyceny, produkcji prototypu lub serii docelowej.
        </p>
        <p>
          Informujemy, że przesyłane pliki mogą zawierać{" "}
          <strong>metadane</strong> (np. informacje o autorze, dacie utworzenia,
          lokalizacji GPS w przypadku zdjęć, dane oprogramowania). Administrator
          nie wykorzystuje metadanych do celów innych niż realizacja zamówienia.
          Zalecamy usunięcie metadanych z plików przed ich przesłaniem, jeśli nie
          życzą sobie Państwo ich przetwarzania.
        </p>
        <p>
          Przesłane pliki przechowywane są przez czas realizacji zamówienia oraz
          przez <strong>12 miesięcy</strong> po jego zakończeniu w celu obsługi
          ewentualnych reklamacji i roszczeń gwarancyjnych. Po upływie tego
          okresu pliki są trwale usuwane z systemów Administratora.
        </p>

        <h3>§ 5. Dobrowolność podania danych</h3>
        <p>
          Podanie danych osobowych jest <strong>dobrowolne</strong>, lecz
          niezbędne do obsługi Państwa zapytania i realizacji zamówienia.
          Niepodanie danych oznaczonych w formularzu jako wymagane uniemożliwi
          odpowiedź na zapytanie lub realizację usługi.
        </p>

        <h3>§ 6. Odbiorcy danych osobowych</h3>
        <p>
          Państwa dane osobowe mogą być przekazywane następującym kategoriom
          odbiorców:
        </p>
        <ul>
          <li>dostawcom usług hostingowych i infrastruktury IT,</li>
          <li>dostawcom usług poczty elektronicznej,</li>
          <li>dostawcom oprogramowania do fakturowania i księgowości,</li>
          <li>
            firmom kurierskim i przewozowym — w zakresie niezbędnym do
            realizacji dostawy,
          </li>
          <li>
            partnerom produkcyjnym — w zakresie niezbędnym do realizacji
            zamówienia, wyłącznie na podstawie umów powierzenia przetwarzania
            danych (art. 28 RODO).
          </li>
        </ul>
        <p>
          Ponadto Państwa dane mogą zostać udostępnione podmiotom uprawnionym na
          podstawie przepisów prawa (np. organy podatkowe, organy ścigania).
        </p>

        <h3>§ 7. Przekazywanie danych do państw trzecich</h3>
        <p>
          W związku z korzystaniem z usług dostawców narzędzi informatycznych
          mających siedzibę poza EOG, np. w USA, przekazywanie odbywa się na
          podstawie:
        </p>
        <ul>
          <li>
            decyzji Komisji Europejskiej z dnia 10 lipca 2023 r. stwierdzającej
            odpowiedni stopień ochrony danych w ramach{" "}
            <strong>EU-US Data Privacy Framework</strong> (w przypadku podmiotów
            certyfikowanych w ramach DPF), lub
          </li>
          <li>
            <strong>standardowych klauzul umownych</strong> przyjętych przez
            Komisję Europejską (art. 46 ust. 2 lit. c RODO).
          </li>
        </ul>

        <h3>§ 8. Prawa osób, których dane dotyczą</h3>
        <p>
          Na podstawie RODO przysługują Państwu następujące prawa:
        </p>
        <ul>
          <li>prawo dostępu do danych (art. 15 RODO),</li>
          <li>prawo do sprostowania danych (art. 16 RODO),</li>
          <li>prawo do usunięcia danych (art. 17 RODO),</li>
          <li>prawo do ograniczenia przetwarzania (art. 18 RODO),</li>
          <li>prawo do przenoszenia danych (art. 20 RODO),</li>
          <li>
            prawo do sprzeciwu wobec przetwarzania opartego na prawnie
            uzasadnionym interesie Administratora (art. 21 RODO),
          </li>
          <li>
            prawo do wniesienia skargi do organu nadzorczego — Prezesa Urzędu
            Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa (art. 77
            RODO).
          </li>
        </ul>
        <p>
          Administrator <strong>nie podejmuje</strong> decyzji opartych wyłącznie
          na zautomatyzowanym przetwarzaniu, w tym profilowaniu (art. 22 RODO).
        </p>
        <p>
          W celu skorzystania z powyższych praw prosimy o kontakt pod adresem
          e-mail: sweep.3d.lab@gmail.com. Administrator udzieli odpowiedzi bez
          zbędnej zwłoki, nie później niż w terminie{" "}
          <strong>jednego miesiąca</strong> od otrzymania żądania.
        </p>

        <h3>§ 9. Bezpieczeństwo danych osobowych</h3>
        <p>
          Administrator stosuje odpowiednie środki techniczne i organizacyjne
          zapewniające bezpieczeństwo przetwarzanych danych osobowych, w
          szczególności:
        </p>
        <ul>
          <li>
            ograniczenie dostępu do danych osobowych wyłącznie do osób
            upoważnionych,
          </li>
          <li>regularne tworzenie kopii zapasowych,</li>
          <li>
            stosowanie zabezpieczeń przed nieautoryzowanym dostępem do systemów
            informatycznych,
          </li>
          <li>
            bezpieczne przechowywanie przesyłanych plików z ograniczonym
            dostępem.
          </li>
        </ul>

        <h3>§ 10. Zmiany Polityki Prywatności</h3>
        <p>
          Administrator zastrzega sobie prawo do wprowadzania zmian w niniejszej
          Polityce Prywatności w celu zapewnienia jej aktualności i zgodności z
          obowiązującymi przepisami prawa. O istotnych zmianach Administrator
          poinformuje za pośrednictwem Serwisu. Aktualna wersja Polityki
          Prywatności jest zawsze dostępna pod adresem:
          https://sweeplab.org/privacy-policy.
        </p>

        <h3>§ 11. Postanowienia końcowe</h3>
        <p>
          Niniejsza Polityka Prywatności obowiązuje od dnia 1 marca 2026.
        </p>
        <p>
          W sprawach nieuregulowanych niniejszą Polityką Prywatności zastosowanie
          mają przepisy RODO, ustawy z dnia 10 maja 2018 r. o ochronie danych
          osobowych oraz inne właściwe przepisy prawa polskiego.
        </p>
      </section>
      <Footer />
    </>
  );
}
